export default "__VITE_ASSET__BJW8zne2__"